import PropTypes from 'prop-types';
import '../../utils/highlight';
import { Link as RouterLink } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactMarkdown from 'react-markdown';
// markdown plugins
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { Link, Typography, Divider } from '@mui/material';
//
import StyledMarkdown from './styles';

// ----------------------------------------------------------------------

Markdown.propTypes = {
  sx: PropTypes.object,
  convertPToDiv: PropTypes.bool,
};

export default function Markdown({ sx, inline = 'false', convertPToDiv = false, ...other }) {
  return (
    <StyledMarkdown sx={{ ...sx, display: inline ? 'inline' : '' }}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw, [remarkGfm, { singleTilde: false }]]}
        components={!convertPToDiv ? components : { ...components, p: ({ ...props }) => <Typography component="div" paragraph {...props} sx={{...sx}}/> }}
        {...other}
      />
    </StyledMarkdown>
  );
}

// ----------------------------------------------------------------------

const components = {
  h1: ({ ...props }) => <Typography variant="h1" gutterBottom {...props} />,
  h2: ({ ...props }) => <Typography variant="h2" gutterBottom {...props} />,
  h3: ({ ...props }) => <Typography variant="h3" gutterBottom {...props} />,
  h4: ({ ...props }) => <Typography variant="h4" gutterBottom {...props} />,
  h5: ({ ...props }) => <Typography variant="h5" gutterBottom {...props} />,
  h6: ({ ...props }) => <Typography variant="h6" gutterBottom {...props} />,
  p: ({ ...props }) => <Typography paragraph {...props} />,
  s1: ({ ...props }) => <Typography variant="subtitle1" paragraph {...props} />,
  s2: ({ ...props }) => <Typography variant="subtitle2" paragraph {...props} />,
  hr: ({ ...props }) => <Divider sx={{ my: 3 }} {...props} />,
  img: ({ ...props }) => <LazyLoadImage {...{ ...props, node: undefined }} />,
  section: ({ ...props }) => <Typography variant="body1" display="inline" gutterBottom {...props} />,
  a: ({ ...props }) => {
    const isExternal = props.href.includes('http') || props.href.includes('www') || props.href.includes('mailto');
    if (
      props.href &&
      props.href.startsWith('mailto:') &&
      props.children &&
      props.children.length === 1 &&
      typeof props.children[0] === 'string' &&
      props.href.replace('mailto:', '') === props.children[0]
    ) {
      // Just render the email as plain text, not a link
      return <span>{props.children[0]}</span>;
    }
    let href;
    if (isExternal && !props.href.includes('http')) {
      href = `https://${props.href}`;
    } else href = props.href;

    return isExternal ? (
      <Link
        target="_blank"
        rel="noopener"
        href={href}
        children={props.children}
        sx={{
          color: '#000',
          textDecoration: 'underline',
          fontSize: '16px',
          '&:hover': { opacity: 0.72 },
        }}
      />
    ) : (
      <Link
        component={RouterLink}
        to={props.href}
        {...props}
        sx={{
          color: '#255070',
        }}
      >
        {props.children}
      </Link>
    );
  },
};
